export class SaasEntitySnapshot {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "snapshotId",
            "baseName": "snapshotId",
            "type": "string",
            "format": ""
        },
        {
            "name": "dateCreated",
            "baseName": "dateCreated",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "status",
            "baseName": "status",
            "type": "string",
            "format": ""
        },
        {
            "name": "hasPartialData",
            "baseName": "hasPartialData",
            "type": "boolean",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return SaasEntitySnapshot.attributeTypeMap;
    }
    constructor() {
    }
}
